module.exports = __webpack_public_path__ + "img/zr-vertical-text.21110e48.svg";